// Returns the first problem with an export request, or null when it can be sent.
export const validateExportRequest = ({
  scope, selectedResource, showTargetUserSelect, targetUserId,
  exportType, selectedHorizon, exportStartDate, exportEndDate,
}) => {
  if (scope === 'resource' && !selectedResource) return 'Please select a resource.';
  // Target user is only mandatory for historical forecast exports, not for market reports
  if (showTargetUserSelect && !targetUserId && exportType === 'historical_forecast') return 'Please select a target user.';
  if (exportType !== 'raw_measurement' && (selectedHorizon === null || selectedHorizon === undefined)) return 'Please select a horizon.';
  if (!exportStartDate || !exportEndDate) return 'Select start and end date.';
  if (new Date(exportStartDate) > new Date(exportEndDate)) return 'Invalid date range.';
  return null;
};
